// extracted by mini-css-extract-plugin
module.exports = {"list":"FilesTagsListInput_list__w8v9G"};